import * as es from './es/common';

const messages = {
  es: {
    common: es,
  },
};

export default messages;
